import { createSelector } from "reselect"
import { computeScopedSegment } from "helpers/filter-scope"
import { getSegment } from "./segment"
import { getEffectiveFilterScope } from "./filter-scope"

export const getEffectiveSegment = createSelector(
  [getSegment, getEffectiveFilterScope],
  computeScopedSegment,
)
